import InputField from "@components/form/InputField";
import MultipleChoiceField from "@components/form/MultipleChoiceField";
import CheckboxField from "@components/form/CheckboxField";
import TimeField from "@components/form/TimeField";
import DateField from "@components/form/DateField";
import FileUploadField from "@components/form/FileUploadField";
import SectionTitleField from "@components/form-builder/SectionTitleField";
import SectionSubtitleField from "@components/form-builder/SectionSubtitleField";
import SignatureField from "@components/form/SignatureField";
import ParagraphField from "@components/form/ParagraphField";
const FieldRenderer = ({
  id,
  item,
  index,
  refKey,
  formData,
  handleChange,
  signatureRefs,
  draftSignatures,
  setDraftSignatures,
}) => {
  switch (item.select) {
    case "Short Answer":
      return (
        <InputField
          label={item.question}
          required={item.required}
          value={formData[index].answer || ""}
          onChange={(e) => handleChange(index, "answer", e.target.value)}
          placeholder={item.value}
        />
      );
    case "Paragraph":
      return (
        <ParagraphField
          item={item}
          index={index}
          formData={formData}
          handleChange={handleChange}
        />
      );
    case "Multiple Choice":
      return (
        <MultipleChoiceField
          label={item.question}
          required={item.required}
          options={item.options}
          formData={formData}
          index={index}
          onChange={handleChange}
        />
      );
    case "Checkboxes":
      return (
        <CheckboxField
          label={item.question}
          required={item.required}
          options={item.options}
          formData={formData}
          index={index}
          onChange={handleChange}
        />
      );
    case "Section Title":
      return <SectionTitleField label={item.value} />;
    case "Section Subtitle":
      return <SectionSubtitleField label={item.value} />;
    case "Date":
      return (
        <DateField
          label={item.question}
          required={item.required}
          value={formData[index].answer || ""}
          onChange={handleChange}
          index={index}
        />
      );
    case "Time":
      return (
        <TimeField
          label={item.question}
          required={item.required}
          value={formData[index].answer || ""}
          onChange={handleChange}
          index={index}
        />
      );
    case "File Upload":
      return (
        <FileUploadField
          label={item.question}
          required={item.required}
          value={formData[index].answer || ""}
          onChange={handleChange}
          index={index}
        />
      );
    case "Signature":
      return (
        <SignatureField
          id={id}
          item={item}
          index={index}
          refKey={refKey}
          formData={formData}
          signatureRefs={signatureRefs}
          draftSignatures={draftSignatures}
          setDraftSignatures={setDraftSignatures}
        />
      );

    default:
      return (
        <p className="text-red-500">Unsupported field type: {item.type}</p>
      );
  }
};

export default FieldRenderer;
